import React from 'react';
import { Script } from 'gatsby';
import Header from './Header';
import JobBanner from './JobBanner';
import Footer from './Footer';

import { LocaleProvider } from './LocaleProvider';
import { PageHead } from './PageHead';

export const PageWrapper = ({
    pageData,
    seoTitle,
    seoDescription,
    seoImage,
    children,
}) => (
    <LocaleProvider pageData={pageData}>
        <PageHead
            seoTitle={seoTitle}
            seoDescription={seoDescription}
            seoImage={seoImage}
        />
        {/*<JobBanner />*/}
        <Header />
        <main className='MainPageWrapper'>
            {children}
        </main>
        <Footer className='FooterPageWrapper'/>
    </LocaleProvider>
);